$(document).ready(function () {
  var $initialCategoriesToggle = jQuery('#tt-megamenu > .toggle_menu');
  if (
    !jQuery('body').hasClass('template-index') &&
    $initialCategoriesToggle.length
  ) {
    $initialCategoriesToggle
      .removeClass('default-open current-open')
      .addClass('current-close');
    jQuery('body').removeClass('menu-current-open');
    jQuery('#tt-megamenu > .tt-mega_menu').hide();
  }

  jQuery('.filter-toggle').on('click', function (e) {
    e.preventDefault();
    jQuery(this).toggleClass('active');
    jQuery('.filter-toggle-wrap').slideToggle('is-visible');
  });
  var filter = jQuery(this).find('.full_width .sorting_wrapper');
  jQuery(this).find('.filter-toggle').insertBefore(filter);

  jQuery('#column-right').insertAfter('#content');
  //jQuery('#shopify-section-footer-style-3,#shopify-section-footer-style-2, #shopify-section-footer-style-1').appendTo('.site-inner');

  jQuery('.site-inner').appendTo('.page-wrapper');

  jQuery('.special-collection,.new-collection').wrapAll(
    "<div class='ttspecial-new shopify-section index-section'><div class='row'></div></div>",
  );

  jQuery(
    '.left_sidebar.template-index.header_style_2 #shopify-section-TT-mega_menu,.left_sidebar.template-index.header_style_2 .tt-homeslider',
  ).wrapAll("<div class='Slider-menu'></div>");
  jQuery('.Slider-menu').insertBefore('.page-bg');
  jQuery(
    '.left_sidebar.template-index.header_style_3 .tt-homeslider',
  ).insertBefore('.pagecontent');
  jQuery('.index-section.ttcms-rightbanner2').insertAfter('.tt-homeslider');
  jQuery('.index-section.services').insertAfter('.ttcms-rightbanner2');
  jQuery('.tt-homeslider,.ttcms-rightbanner2').wrapAll(
    '<div class="slider-banner"><div class="container"><div class="row"></div></div></div>',
  );
  var p_col = jQuery('.ttcmscatbanner1').data('col');
  jQuery('.category-slider .category_slider_content').each(function () {
    jQuery(this)
      .find('contents #shopify-section-catsub-banner1--' + p_col + '')
      .insertBefore('.tthometab-title');
  });
  //video
  var p = jQuery('.popup_overlay');

  jQuery('.play-icone').click(function () {
    jQuery('body').addClass('popup-toggle');
    p.css('display', 'block');
  });
  p.click(function (event) {
    e = event || window.event;
    if (e.target == this) {
      jQuery(p).css('display', 'none');
      jQuery('body').removeClass('popup-toggle');
    }
  });
  jQuery('.popup_close,.slides .slick-arrow').click(function () {
    p.css('display', 'none');
    jQuery('body').removeClass('popup-toggle');
  });
  jQuery('.checkout-btn .shopify-payment-button').addClass('btn');
  //video popup
  function toggleVideo(state) {
    var div = document.getElementById('popupVid');
    var iframe = div.getElementsByTagName('iframe')[0].contentWindow;
    func = state == 'hide' ? 'pauseVideo' : 'playVideo';
    iframe.postMessage(
      '{"event":"command","func":"' + func + '","args":""}',
      '*',
    );
  }

  jQuery('#popup_toggle').click(function () {
    p.css('visibility', 'visible').css('opacity', '1');
  });

  var w_width = $(window).width();
  $('.slider-content-main-wrap').css('width', w_width);
  if ($('.site-header').hasClass('header_transaparent')) {
    $('body.template-index').addClass('header_transaparent');
  }

  var img_id = jQuery('.product-single__thumbs .slick-active.slick-current')
    .find('.product-single__thumb')
    .data('id');
  if (jQuery('.product-lightbox-btn').hasClass(img_id)) {
    jQuery('.product-lightbox-btn.' + img_id).show();
  }

  jQuery('.filter-left').on('click', function (e) {
    e.preventDefault();
    jQuery(this).toggleClass('active');
    jQuery('.off-canvas.position-left').toggleClass('is-open');
    jQuery('.js-off-canvas-overlay.is-overlay-fixed').toggleClass(
      'is-visible is-closable',
    );
  });
  jQuery('.is-overlay-fixed').on('click', function (e) {
    e.preventDefault();
    jQuery('.filter-left').trigger('click');
    jQuery('.filter-right').trigger('click');
  });
  jQuery('.filter-right').on('click', function (e) {
    e.preventDefault();
    jQuery(this).toggleClass('active');
    jQuery('.off-canvas.position-right').toggleClass('is-open');
    jQuery('.js-off-canvas-overlay.is-overlay-fixed').toggleClass(
      'is-visible is-closable',
    );
  });
  jQuery('.off-canvas .sidebar_close').on('click', function (e) {
    e.preventDefault();
    jQuery('.off-canvas.position-left').removeClass('is-open');
    jQuery('.off-canvas.position-right').removeClass('is-open');
    jQuery('.js-off-canvas-overlay.is-overlay-fixed').removeClass(
      'is-visible is-closable',
    );
  });
  $('.product-360-button a').magnificPopup({
    type: 'inline',
    mainClass: 'mfp-fade',
    removalDelay: 160,
    disableOn: false,
    preloader: false,
    fixedContentPos: false,
    callbacks: {
      open: function () {
        $(window).resize();
      },
    },
  });
  countDownIni('.flip-countdown,.js-flip-countdown');
  /** popup Video **/

  $('.popup-video').magnificPopup({
    disableOn: 300,
    type: 'iframe',
    mainClass: 'mfp-fade',
    removalDelay: 160,
    preloader: false,
    fixedContentPos: false,
  });

  /***/

  if (
    $('a.product-lightbox-btn').length > 0 ||
    $('a.product-video-popup').length > 0
  ) {
    $('.product-single__photos .gallery,.design_2 .product-img').magnificPopup({
      delegate: 'a', // child items selector, by clicking on it popup will open
      type: 'image',
      tLoading:
        '<div class="please-wait dark"><span></span><span></span><span></span></div>',
      removalDelay: 300,
      closeOnContentClick: true,
      gallery: {
        enabled: true,
        navigateByImgClick: false,
        preload: [0, 1],
      },
      image: {
        verticalFit: false,
        tError: '<a href="%url%">The image #%curr%</a> could not be loaded.',
      },
      callbacks: {
        beforeOpen: function () {
          var productVideo = $('.product-video-popup').attr('href');
          if (productVideo) {
            this.st.mainClass = 'has-product-video';
            var galeryPopup = $.magnificPopup.instance;
            galeryPopup.items.push({
              src: productVideo,
              type: 'iframe',
            });
            galeryPopup.updateItemHTML();
          }
        },
        open: function () {},
      },
      // other options
    });
  }
  $('.design_3 .product-img,.design_5 .pro_img').magnificPopup({
    delegate: 'a', // child items selector, by clicking on it popup will open
    type: 'image',
    tLoading:
      '<div class="please-wait dark"><span></span><span></span><span></span></div>',
    removalDelay: 300,
    closeOnContentClick: true,
    gallery: {
      enabled: true,
      navigateByImgClick: false,
      preload: [0, 1],
    },
    image: {
      verticalFit: false,
      tError: '<a href="%url%">The image #%curr%</a> could not be loaded.',
    },
    callbacks: {
      beforeOpen: function () {
        var productVideo = $('.product-video-popup').attr('href');
        if (productVideo) {
          this.st.mainClass = 'has-product-video';
          var galeryPopup = $.magnificPopup.instance;
          galeryPopup.items.push({
            src: productVideo,
            type: 'iframe',
          });
          galeryPopup.updateItemHTML();
        }
      },
      open: function () {},
    },
    // other options
  });
  $('body').on('click', '.product-lightbox-btn', function (e) {
    $('.product-wrapper-owlslider').find('.owl-item.active a').click();
    e.preventDefault();
  });

  /* special-product product thumb img*/
  jQuery('.special-collection .product-single__thumbs a').on(
    'click',
    function () {
      var src = jQuery(this).data('fullsrc');
      if (src != '') {
        jQuery(this)
          .closest('.product-wrapper')
          .find('img.grid-view-item__image')
          .first()
          .attr('src', src);
      }
      jQuery(this)
        .parent('.grid-item')
        .addClass('open')
        .siblings('.grid-item')
        .removeClass('open');
    },
  );

  $('.qtyplus').on('click', function (e) {
    e.preventDefault();
    var input_val = jQuery(this).parents('.qty-box-set').find('.quantity');
    var currentVal = parseInt(
      jQuery(this).parents('.qty-box-set').find('.quantity').val(),
    );
    if (!isNaN(currentVal)) {
      jQuery(this)
        .parents('.qty-box-set')
        .find('.quantity')
        .val(currentVal + 1);
    } else {
      jQuery(this).parents('.qty-box-set').find('.quantity').val(1);
    }
  });

  $('.qtyminus').on('click', function (e) {
    e.preventDefault();
    var input_val = jQuery(this).parents('.qty-box-set').find('.quantity');
    var currentVal = parseInt(
      jQuery(this).parents('.qty-box-set').find('.quantity').val(),
    );
    if (!isNaN(currentVal) && currentVal > 1) {
      jQuery(this)
        .parents('.qty-box-set')
        .find('.quantity')
        .val(currentVal - 1);
    } else {
      jQuery(this).parents('.qty-box-set').find('.quantity').val(1);
    }
  });

  $('body').on('click', '.cart-qty-btn', function (e) {
    e.preventDefault();
    var input = jQuery(this).siblings('[data-quantity-input]');
    var currentValue = parseInt(input.val(), 10) || 1;
    var nextValue = jQuery(this).hasClass('cart-qty-plus')
      ? currentValue + 1
      : Math.max(1, currentValue - 1);

    if (nextValue !== currentValue) {
      input.val(nextValue).trigger('change');
    }
  });

  $('#navToggle').on('click', function (e) {
    jQuery(this).next('.Site-navigation').slideToggle(500);
  });
  $('.menu_toggle_wrap #navToggle').on('click', function (e) {
    jQuery(this).parent().next('.Site-navigation').slideToggle(500);
  });

  /*Scroll to top js*/
  jQuery('#GotoTop').on('click', function () {
    jQuery('html, body').animate(
      {
        scrollTop: 0,
      },
      '1000',
    );
    return false;
  });

  jQuery('.site-header__search.search-full .serach_icon').on(
    'click',
    function (e) {
      e.preventDefault();
      jQuery(this).toggleClass('active');
      jQuery('body').toggleClass('search_full_active');
      jQuery('.full-search-wrapper').addClass('search-overlap');
      jQuery('.search-bar > input').focus();
    },
  );
  jQuery('.site-header__search.search-full .close-search').on(
    'click',
    function () {
      jQuery('.site-header__search.search-full .serach_icon').removeClass(
        'active',
      );
      jQuery('.full-search-wrapper').removeClass('search-overlap');
      jQuery('body').removeClass('search_full_active');
    },
  );

  jQuery('.site-header__search:not(.search-full) .serach_icon').on(
    'click',
    function () {
      jQuery('.search_wrapper').slideToggle('fast');
      jQuery('.search-bar > input').focus();
      jQuery(this).toggleClass('active');
      jQuery('.customer_account').slideUp('fast');
      jQuery('#slidedown-cart').slideUp('fast');
      jQuery('#Sticky-slidedown-cart').removeClass('cart-drawer-open').hide();
      jQuery('body').removeClass('cart-open cart_active cart-drawer-active');
    },
  );
  jQuery('.myaccount  .dropdown-toggle').on('click', function (event) {
    event.preventDefault();
    jQuery(this).toggleClass('open');
    jQuery('.customer_account').slideToggle('fast');
    jQuery('.site-header__search:not(.search-full) .serach_icon').removeClass(
      'active',
    );
    jQuery('body').removeClass('search_full_active');
    jQuery('body').removeClass('cart_active');
    jQuery(
      'body.header_style_1,body.header_style_2,body.header_style_3',
    ).toggleClass('myaccount_active');
    jQuery('.currency_wrapper').removeClass('active');
    jQuery('body.header_style_2').removeClass('currency-open');
    jQuery('.header_2 .language_wrapper').removeClass('active');
    jQuery('body.header_style_2').removeClass('language-open');
    jQuery('.header_style_2 .currencies.flag-dropdown-menu').slideUp('fast');
    jQuery('.header_style_2 .disclosure-list').slideUp('fast');
    jQuery('.site-header .search_wrapper').slideUp('fast');
    jQuery('#slidedown-cart').slideUp('fast');
    jQuery('#Sticky-slidedown-cart').removeClass('cart-drawer-open').hide();
    jQuery('body').removeClass('cart-open cart-drawer-active');
    jQuery('.site-header .site-header_cart_link').removeClass('active');
  });

  function closeMyaccountDropdown() {
    var $toggle = jQuery('.myaccount .dropdown-toggle');

    if (!$toggle.length) {
      return;
    }

    $toggle.removeClass('open');
    jQuery('.customer_account').stop(true, true).slideUp('fast');
    jQuery(
      'body.header_style_1,body.header_style_2,body.header_style_3',
    ).removeClass('myaccount_active');
  }

  jQuery(document).on('click', function (event) {
    if (jQuery(event.target).closest('.myaccount').length === 0) {
      closeMyaccountDropdown();
    }
  });

  jQuery(document).on('keydown', function (event) {
    if (event.key === 'Escape') {
      closeMyaccountDropdown();
    }
  });

  $('.header_currency .currency_wrapper.dropdown-toggle').on(
    'click',
    function (event) {
      event.preventDefault();
      $(this).toggleClass('active');
      jQuery('.customer_account').stop();
      jQuery('body.header_style_2').toggleClass('currency-open');
      jQuery('body.header_style_2').removeClass('language-open');
      jQuery('body.header_style_2').removeClass('cart_active');
      jQuery('body.header_style_2').removeClass('language-open');
      jQuery('.header_2 .language_wrapper').removeClass('active');
      jQuery('.currencies.flag-dropdown-menu').slideToggle('fast');
      jQuery('.header_2 .customer_account').slideUp('fast');
      jQuery('.header_language .disclosure-list').slideUp('fast');
      jQuery('.header_2 #slidedown-cart').slideUp('fast');
      jQuery('.header_2 #Sticky-slidedown-cart')
        .removeClass('cart-drawer-open')
        .hide();
      jQuery('body').removeClass('cart-open cart-drawer-active');
      jQuery('body.header_style_2').removeClass('myaccount_active');
    },
  );

  $('.header_language .disclosure__toggle').on('click', function (event) {
    event.preventDefault();
    jQuery('.customer_account').stop();
    jQuery('body.header_style_2').toggleClass('language-open');
    jQuery('body.header_style_2').removeClass('currency-open');
    jQuery('body.header_style_2').removeClass('cart_active');
    jQuery('.header_2 .currency_wrapper').removeClass('active');
    jQuery('.disclosure-list').slideToggle('fast');
    $(this).toggleClass('active');
    jQuery('.header_2 .customer_account').slideUp('fast');
    jQuery('.currencies.flag-dropdown-menu').slideUp('fast');
    jQuery('.header_2 #slidedown-cart').slideUp('fast');
    jQuery('.header_2 #Sticky-slidedown-cart')
      .removeClass('cart-drawer-open')
      .hide();
    jQuery('body').removeClass('cart-open cart-drawer-active');
    jQuery('body.header_style_2').removeClass('myaccount_active');
  });
  $('body .slider-specialproduct .product-single__thumbs').owlCarousel({
    items: 3, //1 items above 1000px browser width
    nav: true,
    dots: false,
    loop: false,
    autoplay: false,
    slideTransition: 'linear',
    responsive: {
      1279: {
        items: 3,
      },
      100: {
        items: 2,
      },
    },
  });
  if (
    jQuery('body:not(.rtl)').hasClass('left_sidebar') ||
    jQuery('body:not(.rtl)').hasClass('right_sidebar')
  ) {
    $(
      'body.left_sidebar:not(.rtl) .slider-specialproduct' ||
        'body.right_sidebar:not(.rtl) .slider-specialproduct',
    ).owlCarousel({
      items: 2, //10 items above 1000px browser width
      nav: true,
      autoplay: true,
      autoplaySpeed: 1500,
      autoplayHoverPause: true,
      dots: false,
      responsive: {
        100: {
          items: 1,
        },
        680: {
          items: 1,
        },
        992: {
          items: 1,
        },
        1200: {
          items: 1,
        },
        1700: {
          items: 1,
        },
      },
    });
  } else {
    $(
      'body:not(.rtl.left_sidebar) .slider-specialproduct' ||
        'body:not(.rtl.right_sidebar) .slider-specialproduct',
    ).owlCarousel({
      items: 1, //10 items above 1000px browser width
      nav: true,
      dots: false,
      autoplay: true,
      autoplaySpeed: 1500,
      autoplayHoverPause: true,
      responsive: {
        100: {
          items: 1,
        },
        680: {
          items: 1,
        },
        992: {
          items: 1,
        },
        1200: {
          items: 1,
        },
        1700: {
          items: 1,
        },
      },
    });
  }

  if (
    jQuery('body.rtl.left_sidebar').hasClass('left_sidebar') ||
    jQuery('body.rtl.right_sidebar').hasClass('left_sidebar')
  ) {
    $(
      'body.rtl.left_sidebar .slider-specialproduct' ||
        'body.rtl.right_sidebar .slider-specialproduct',
    ).owlCarousel({
      items: 1, //10 items above 1000px browser width
      nav: true,
      dots: false,
      autoplay: true,
      autoplaySpeed: 1500,
      autoplayHoverPause: true,
      rtl: true,
      responsive: {
        100: {
          items: 1,
        },
        680: {
          items: 1,
        },
        992: {
          items: 1,
        },
        1200: {
          items: 1,
        },
        1700: {
          items: 1,
        },
      },
    });
  } else {
    $(
      'body.rtl:not(.left_sidebar) .slider-specialproduct' ||
        'body.rtl:not(.right_sidebar) .slider-specialproduct',
    ).owlCarousel({
      items: 1, //10 items above 1000px browser width
      nav: true,
      dots: false,
      autoplay: true,
      autoplaySpeed: 1500,
      autoplayHoverPause: true,
      rtl: true,
      responsive: {
        100: {
          items: 1,
        },
        680: {
          items: 1,
        },
        992: {
          items: 1,
        },
        1200: {
          items: 1,
        },
        1700: {
          items: 1,
        },
      },
    });
  }
  //ttcmssubbanner
  $('.ttcms-subbanner .ttbanner-wrap').owlCarousel({
    items: 3, //1 items above 1000px browser width
    nav: false,
    dots: false,
    loop: false,
    autoplay: true,
    responsive: {
      992: {
        items: 3,
      },
      481: {
        items: 2,
      },
      100: {
        items: 1,
      },
    },
  });

  $('.slider-specialproduct-wrap').each(function () {
    if ($(this).find('.owl-nav').hasClass('disabled')) {
      $(this).find('.customNavigation').hide();
    } else {
      $(this).find('.customNavigation').show();
    }
  });
  $('.slider-specialproduct-wrap .customNavigation .next').click(function () {
    var wrap = $(this).closest('.slider-specialproduct-wrap');
    $(wrap).find('.slider-specialproduct').trigger('next.owl');
  });
  $('.slider-specialproduct-wrap .customNavigation .prev').click(function () {
    var wrap = $(this).closest('.slider-specialproduct-wrap');
    $(wrap).find('.slider-specialproduct').trigger('prev.owl');
  });
  /*---------------- Newproduct ---------------*/
  if (
    jQuery('body:not(.rtl)').hasClass('left_sidebar') ||
    jQuery('body:not(.rtl)').hasClass('right_sidebar')
  ) {
    $(
      'body.left_sidebar:not(.rtl) .slider-newproduct' ||
        'body.right_sidebar:not(.rtl) .slider-newproduct',
    ).owlCarousel({
      items: 1, //10 items above 1000px browser width
      nav: true,
      autoplay: false,
      autoplaySpeed: 1500,
      autoplayHoverPause: true,
      dots: false,
      responsive: {
        100: {
          items: 1,
        },
        768: {
          items: 2,
        },
        1200: {
          items: 1,
        },
        1460: {
          items: 1,
        },
      },
    });
  } else {
    $(
      'body:not(.rtl.left_sidebar) .slider-newproduct' ||
        'body:not(.rtl.right_sidebar) .slider-newproduct',
    ).owlCarousel({
      items: 1, //10 items above 1000px browser width
      nav: true,
      dots: false,
      autoplay: false,
      autoplaySpeed: 1500,
      autoplayHoverPause: true,
      responsive: {
        100: {
          items: 1,
        },
        768: {
          items: 2,
        },
        1200: {
          items: 1,
        },
        1460: {
          items: 1,
        },
      },
    });
  }

  if (
    jQuery('body.rtl.left_sidebar').hasClass('left_sidebar') ||
    jQuery('body.rtl.right_sidebar').hasClass('left_sidebar')
  ) {
    $(
      'body.rtl.left_sidebar .slider-newproduct' ||
        'body.rtl.right_sidebar .slider-newproduct',
    ).owlCarousel({
      items: 1, //10 items above 1000px browser width
      nav: true,
      dots: false,
      autoplay: false,
      autoplaySpeed: 1500,
      autoplayHoverPause: true,
      rtl: true,
      responsive: {
        100: {
          items: 1,
        },
        768: {
          items: 2,
        },
        1200: {
          items: 1,
        },
        1460: {
          items: 1,
        },
      },
    });
  } else {
    $(
      'body.rtl:not(.left_sidebar) .slider-newproduct' ||
        'body.rtl:not(.right_sidebar) .slider-newproduct',
    ).owlCarousel({
      items: 1, //10 items above 1000px browser width
      nav: true,
      dots: false,
      autoplay: false,
      autoplaySpeed: 1500,
      autoplayHoverPause: true,
      rtl: true,
      responsive: {
        100: {
          items: 1,
        },
        768: {
          items: 2,
        },
        1200: {
          items: 1,
        },
        1460: {
          items: 1,
        },
      },
    });
  }

  $('.slider-newproduct-wrap').each(function () {
    if ($(this).find('.owl-nav').hasClass('disabled')) {
      $(this).find('.customNavigation').hide();
    } else {
      $(this).find('.customNavigation').show();
    }
  });
  $('.slider-newproduct-wrap .customNavigation .next').click(function () {
    var wrap = $(this).closest('.slider-newproduct-wrap');
    $(wrap).find('.slider-newproduct').trigger('next.owl');
  });
  $('.slider-newproduct-wrap .customNavigation .prev').click(function () {
    var wrap = $(this).closest('.slider-newproduct-wrap');
    $(wrap).find('.slider-newproduct').trigger('prev.owl');
  });

  /*---------------- END ---------------*/

  $('.slider-specialproduct .product-wrapper,.product-single').each(
    function () {
      var $desc = $(this).find('.product-description .progress');
      var $qty = $(this).find('.quantity');
      var $pbar = $(this).find('.progress-bar');
      var $progress = $desc;
      var $progressBar = $pbar;
      var $quantity = $qty.html();
      var currentWidth = parseInt($progressBar.css('width'));
      var allowedWidth = parseInt($progress.css('width'));
      var addedWidth = currentWidth + parseInt($quantity);
      if (addedWidth > allowedWidth) {
        addedWidth = allowedWidth;
      }
      var progress = (addedWidth / allowedWidth) * 100;
      $progressBar.animate({ width: progress + '%' }, 100);
    },
  );

  var p_col = jQuery('.slider-bestproduct').data('col');
  $('body:not(.rtl) .slider-bestproduct').owlCarousel({
    items: p_col, //10 items above 1000px browser width
    nav: true,
    autoplay: true,
    autoplaySpeed: 1500,
    dots: false,
    responsive: {
      100: {
        items: 1,
      },
      700: {
        items: 2,
      },
      1200: {
        items: 3,
      },
      1460: {
        items: 3,
      },
      1700: {
        items: p_col,
      },
    },
  });

  $('body.rtl .slider-bestproduct').owlCarousel({
    items: p_col, //10 items above 1000px browser width
    nav: true,
    dots: false,
    autoplay: true,
    autoplaySpeed: 1500,
    responsive: {
      100: {
        items: 1,
      },
      700: {
        items: 2,
      },
      1200: {
        items: 3,
      },
      1460: {
        items: 3,
      },
      1700: {
        items: p_col,
      },
    },
  });

  $('.slider-bestproduct-wrap').each(function () {
    if ($(this).find('.owl-nav').hasClass('disabled')) {
      $(this).find('.customNavigation').hide();
    } else {
      $(this).find('.customNavigation').show();
    }
  });
  $('.slider-bestproduct-wrap .customNavigation .next').click(function () {
    var wrap = $(this).closest('.slider-bestproduct-wrap');
    $(wrap).find('.slider-bestproduct').trigger('next.owl');
  });
  $('.slider-bestproduct-wrap .customNavigation .prev').click(function () {
    var wrap = $(this).closest('.slider-bestproduct-wrap');
    $(wrap).find('.slider-bestproduct').trigger('prev.owl');
  });

  $('body .header_service').owlCarousel({
    items: 1, //1 items above 1000px browser width
    nav: true,
    dots: false,
    loop: false,
    autoplay: true,
    rtl: false,
    autoplaySpeed: 1000,
    autoplayHoverPause: true,
    smartSpeed: 450,
    animateIn: 'fadeIn',
    animateOut: 'fadeOut',
    responsive: {
      1430: {
        items: 1,
      },
      100: {
        items: 1,
      },
    },
  });

  $('.service-header').each(function () {
    if ($(this).find('.owl-nav').hasClass('disabled')) {
      $(this).find('.customNavigation').hide();
    } else {
      $(this).find('.customNavigation').show();
    }
  });
  $('.header_ser_next').click(function () {
    $('.header_service').trigger('next.owl');
  });
  $('.header_ser_prev').click(function () {
    $('.header_service').trigger('prev.owl');
  });

  $('body:not(.rtl) .collection-desc-wrap .cat-banner').owlCarousel({
    items: 1, //1 items above 1000px browser width
    nav: false,
    dots: true,
    loop: false,
    autoplay: true,
    rtl: false,
    responsive: {
      1279: {
        items: 1,
      },
      600: {
        items: 1,
      },
    },
  });
  $('body.rtl .collection-desc-wrap .cat-banner').owlCarousel({
    items: 1, //1 items above 1000px browser width
    nav: false,
    dots: true,
    loop: false,
    autoplay: true,
    rtl: true,
    responsive: {
      1279: {
        items: 1,
      },
      600: {
        items: 1,
      },
    },
  });
  $('body .header_3 .ttcmsheader-services .services').owlCarousel({
    items: 2, //1 items above 1000px browser width
    nav: true,
    dots: true,
    loop: false,
    autoplay: true,
    responsive: {
      1750: {
        items: 2,
      },
      992: {
        items: 1,
      },
      768: {
        items: 2,
      },
      600: {
        items: 2,
      },
      320: {
        items: 1,
      },
    },
  });
  $(
    'body #shopify-section-footer-style-1 .ttcmsfooter-services .services',
  ).owlCarousel({
    items: 2, //1 items above 1000px browser width
    nav: true,
    dots: true,
    loop: false,
    autoplay: true,
    responsive: {
      1460: {
        items: 2,
      },
      992: {
        items: 1,
      },
      768: {
        items: 2,
      },
      600: {
        items: 2,
      },
      100: {
        items: 1,
      },
    },
  });
  $(
    'body #shopify-section-footer-style-2 .ttcmsfooter-services .services',
  ).owlCarousel({
    items: 4, //1 items above 1000px browser width
    nav: true,
    dots: true,
    loop: false,
    autoplay: true,
    responsive: {
      1460: {
        items: 4,
      },
      992: {
        items: 3,
      },
      768: {
        items: 3,
      },
      481: {
        items: 2,
      },
      100: {
        items: 2,
      },
    },
  });
  $(
    'body #shopify-section-footer-style-3 .ttcmsfooter-services .services',
  ).owlCarousel({
    items: 5, //1 items above 1000px browser width
    nav: true,
    dots: true,
    loop: false,
    autoplay: true,
    responsive: {
      1460: {
        items: 5,
      },
      1200: {
        items: 4,
      },
      992: {
        items: 3,
      },
      481: {
        items: 2,
      },
      100: {
        items: 1,
      },
    },
  });
  $('body:not(.rtl) .widget_top_rated_products .top-products').owlCarousel({
    items: 1, //1 items above 1000px browser width
    nav: true,
    dots: true,
    loop: false,
    autoplay: true,
    rtl: false,
    responsive: {
      1279: {
        items: 1,
      },
      600: {
        items: 1,
      },
    },
  });
  $('body.rtl .widget_top_rated_products .top-products').owlCarousel({
    items: 1, //1 items above 1000px browser width
    nav: true,
    dots: true,
    loop: false,
    autoplay: true,
    rtl: true,
    responsive: {
      1279: {
        items: 1,
      },
      600: {
        items: 1,
      },
    },
  });

  $('body:not(.rtl) .special-product-div .product-image.style1').owlCarousel({
    items: 1, //1 items above 1000px browser width
    nav: false,
    dots: true,
    loop: false,
    autoplay: false,
    slideTransition: 'linear',
    rtl: false,
    responsive: {
      1279: {
        items: 1,
      },
      600: {
        items: 1,
      },
    },
  });
  $('body.rtl .special-product-div .product-image.style1').owlCarousel({
    items: 1, //1 items above 1000px browser width
    nav: false,
    dots: true,
    loop: false,
    autoplay: false,
    slideTransition: 'linear',
    rtl: true,
    responsive: {
      1279: {
        items: 1,
      },
      600: {
        items: 1,
      },
    },
  });

  $('body:not(.rtl) .services .block_content').owlCarousel({
    items: 4, //1 items above 1000px browser width
    nav: true,
    dots: true,
    loop: false,
    autoplay: true,
    rewindNav: true,
    rtl: false,
    responsive: {
      1600: {
        items: 6,
      },
      1200: {
        items: 5,
      },
      992: {
        items: 4,
      },
      767: {
        items: 3,
      },
      481: {
        items: 2,
      },
      100: {
        items: 1,
      },
    },
  });
  $('body.rtl .services .block_content').owlCarousel({
    items: 4, //1 items above 1000px browser width
    nav: true,
    dots: true,
    loop: false,
    autoplay: true,
    rtl: true,
    responsive: {
      1600: {
        items: 6,
      },
      1200: {
        items: 5,
      },
      992: {
        items: 4,
      },
      767: {
        items: 3,
      },
      481: {
        items: 2,
      },
      100: {
        items: 1,
      },
    },
  });

  $('body:not(.rtl) .ttleft-testimonial-wrap .testimonials_wrap').owlCarousel({
    items: 1, //1 items above 1000px browser width
    nav: true,
    dots: true,
    loop: false,
    autoplay: true,
    rtl: false,
    responsive: {
      1279: {
        items: 1,
      },
      600: {
        items: 1,
      },
    },
  });
  $('body.rtl .ttleft-testimonial-wrap .testimonials_wrap').owlCarousel({
    items: 1, //1 items above 1000px browser width
    nav: true,
    dots: true,
    loop: false,
    autoplay: true,
    rtl: true,
    responsive: {
      1279: {
        items: 1,
      },
      600: {
        items: 1,
      },
    },
  });

  $('body:not(.rtl) #tt-megamenu .list_product_menu_content').owlCarousel({
    items: 3, //1 items above 1000px browser width
    nav: true,
    autoPlay: true,
    autoplaySpeed: 1000,
    stopOnHover: false,
    loop: false,
    dots: true,
    responsive: {
      768: {
        items: 3,
      },
      481: {
        items: 2,
      },
      100: {
        items: 1,
      },
    },
  });
  $('body.rtl #tt-megamenu .list_product_menu_content').owlCarousel({
    items: 3, //1 items above 1000px browser width
    nav: true,
    autoPlay: true,
    autoplaySpeed: 1000,
    rtl: true,
    stopOnHover: false,
    loop: false,
    dots: true,
    responsive: {
      768: {
        items: 3,
      },
      481: {
        items: 2,
      },
      100: {
        items: 1,
      },
    },
  });

  $('body:not(.rtl) .category_cms_feature').owlCarousel({
    nav: true,
    dots: false,
    autoplay: true,
    autoplaySpeed: 1500,
    loop: false,
    responsive: {
      100: {
        items: 1,
      },
      544: {
        items: 2,
      },
      1200: {
        items: 3,
      },
      1460: {
        items: 3,
      },
    },
  });
  $('body.rtl .category_cms_feature').owlCarousel({
    nav: true,
    rtl: true,
    loop: false,
    autoplay: true,
    autoplaySpeed: 1500,
    dots: false,
    responsive: {
      100: {
        items: 1,
      },
      544: {
        items: 2,
      },
      1200: {
        items: 3,
      },
      1460: {
        items: 3,
      },
    },
  });

  if (jQuery('.category_cms_feature .owl-nav').hasClass('disabled')) {
    jQuery('.category_cms_feature_wrap .customNavigation').hide();
  } else {
    jQuery('.category_cms_feature_wrap .customNavigation').show();
  }
  jQuery('.category_cms_feature_wrap .customNavigation .next').click(
    function () {
      jQuery('.category_cms_feature_wrap .category_cms_feature').trigger(
        'next.owl',
      );
    },
  );
  jQuery('.category_cms_feature_wrap .customNavigation .prev').click(
    function () {
      jQuery('.category_cms_feature_wrap .category_cms_feature').trigger(
        'prev.owl',
      );
    },
  );

  var brandsowl = $('body:not(.rtl) #brands_list_slider');
  var brandsowlrtl = $('body.rtl #brands_list_slider');
  brandsowl.owlCarousel({
    items: 6, //10 items above 1000px browser width
    dots: false,
    loop: false,
    autoplay: true,
    autoplaySpeed: 1500,
    autoplayHoverPause: true,
    nav: true,
    responsive: {
      100: {
        items: 2,
      },
      481: {
        items: 3,
      },
      768: {
        items: 4,
      },
      1200: {
        items: 5,
      },
      1630: {
        items: 6,
      },
    },
  });
  brandsowlrtl.owlCarousel({
    items: 6, //10 items above 1000px browser width
    dots: false,
    loop: false,
    nav: true,
    autoplay: true,
    autoplaySpeed: 1500,
    autoplayHoverPause: true,
    rtl: true,
    responsive: {
      100: {
        items: 2,
      },
      481: {
        items: 3,
      },
      768: {
        items: 4,
      },
      1200: {
        items: 5,
      },
      1630: {
        items: 6,
      },
    },
  });
  $('.brand-bar').each(function () {
    if ($(this).find('.owl-nav').hasClass('disabled')) {
      $(this).find('.customNavigation').hide();
    } else {
      $(this).find('.customNavigation').show();
    }
  });
  $('.brand_next').click(function () {
    $('.tt-brand_slider').trigger('next.owl');
  });
  $('.brand_prev').click(function () {
    $('.tt-brand_slider').trigger('prev.owl');
  });

  $(
    '.btn_wrapper .quick-view-wrap .btn,.product-wrapper .add_tocart .btn',
  ).click(function () {
    $(this).addClass('loading');
    setTimeout(function () {
      $(
        '.btn_wrapper .quick-view-wrap .btn,.product-wrapper .add_tocart .btn',
      ).removeClass('loading');
    }, 2000);
  });

  $('.headerbanner-close').on('click', function () {
    $('.ttcmstopbanner').slideToggle('slow', function () {});
    jQuery('body').addClass('headerbanner-close');
  });

  var $categoriesToggle = $('#tt-megamenu .toggle_menu');
  var $categoriesPanel = $('#tt-megamenu > .tt-mega_menu');

  if (!$('body').hasClass('template-index') && $categoriesToggle.length) {
    $categoriesToggle
      .removeClass('default-open current-open')
      .addClass('current-close');
    $('body').removeClass('menu-current-open');
    $categoriesPanel.hide();
  }

  function closeCategoriesMenu() {
    var $toggle = $('#tt-megamenu .toggle_menu');
    if (!$toggle.length) {
      return;
    }

    $toggle.addClass('current-close').removeClass('current-open');
    $('body').removeClass('menu-current-open');
    $categoriesPanel.stop(true, true).slideUp('2000');
  }

  $categoriesToggle.click(function () {
    if ($(this).hasClass('default-open') && $(window).width() < 992) {
      if ($(this).hasClass('current-close')) {
        $(this).addClass('current-open');
        $('body').addClass('menu-current-open');
        $(this).removeClass('current-close');
        $categoriesPanel.stop(true, true).slideToggle('2000');
      } else {
        $(this).removeClass('default-open');
        $(this).addClass('current-open');
        $('body').addClass('menu-current-open');
        $(this).removeClass('current-close');
        $categoriesPanel.stop(true, true).slideToggle('2000');
      }
    } else if ($(this).hasClass('default-open')) {
      if ($(this).hasClass('current-close')) {
        $(this).addClass('current-open');
        $('body').addClass('menu-current-open');
        $(this).removeClass('current-close');
        $categoriesPanel.stop(true, true).slideToggle('2000');
      } else if ($(this).hasClass('current-open')) {
        $(this).addClass('current-close');
        $(this).removeClass('current-open');
        $('body').removeClass('menu-current-open');
        $categoriesPanel.stop(true, true).slideToggle('2000');
      }
    } else {
      if ($(this).hasClass('current-open')) {
        $(this).addClass('current-close');
        $('body').removeClass('menu-current-open');
        $(this).removeClass('current-open');
        $categoriesPanel.stop(true, true).slideToggle('2000');
      } else {
        $(this).addClass('current-open');
        $(this).removeClass('current-close');
        $('body').addClass('menu-current-open');
        $categoriesPanel.stop(true, true).slideToggle('2000');
      }
    }

    if (
      $(this).hasClass('default-open') &&
      !$('.sticky_header').hasClass('fixed')
    ) {
      $(this).addClass('current-close');
      $(this).removeClass('default-open');
      $categoriesPanel.stop(true, true).slideToggle('2000');
    }
    if (
      $(this).hasClass('default-open') &&
      $('.sticky_header').hasClass('fixed')
    ) {
      $(this).addClass('current-open');
      $('body').addClass('menu-current-open');
      $(this).removeClass('default-open');
      $categoriesPanel.stop(true, true).slideDown('2000');
    }
    $(this).attr(
      'aria-expanded',
      $(this).hasClass('current-open') ? 'true' : 'false',
    );
  });

  $categoriesToggle.on('keydown', function (event) {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      $(this).trigger('click');
    }
  });

  $(document).on('click', function (event) {
    var $target = $(event.target);
    var clickedInsideMenu =
      $target.closest('#tt-megamenu .tt-mega_menu').length > 0;
    var clickedToggle = $target.closest('#tt-megamenu .toggle_menu').length > 0;
    var isMenuOpen =
      $categoriesToggle.hasClass('current-open') ||
      $categoriesPanel.is(':visible');

    if (isMenuOpen && !clickedInsideMenu && !clickedToggle) {
      closeCategoriesMenu();
    }
  });
});

function moremenu() {
  var max_elem = $('body').hasClass('header_style_3') ? 6 : 4;
  var items = $('.topmenu #accessibleNav > li');
  var surplus = items.slice(max_elem, items.length);
  if (surplus.length <= 1) {
    $('.topmenu #accessibleNav').css('display', 'flex');
    return;
  }
  surplus.wrapAll(
    '<li class="more_menu site-nav--has-dropdown menu-item-depth-0"><ul class="top-link sub-nav__dropdown sub-menu mobile-nav__sublist">',
  );
  jQuery('.more_menu').prepend(
    '<a href="#" class="level-top topmega-menu-link">More</a>',
  );
  jQuery('.more_menu').mouseover(function () {
    jQuery(this).children('ul').addClass('shown-link');
    jQuery('body').addClass('menu-open');
  });
  jQuery('.more_menu').mouseout(function () {
    jQuery(this).children('ul').removeClass('shown-link');
    jQuery('body').removeClass('menu-open');
  });
  $('.topmenu #accessibleNav').css('display', 'flex');
}
function refreshHeaderMenuLayout() {
  if (jQuery(window).width() >= 992) {
    jQuery('.header_style_3 .menu-bar .topmenu #accessibleNav').css(
      'display',
      'flex',
    );
  }
}
jQuery(document).ready(function () {
  moremenu();
  refreshHeaderMenuLayout();
});

jQuery(window).scroll(function () {
  if (jQuery(document).height() > jQuery(window).height()) {
    var scroll = jQuery(window).scrollTop();
    if (scroll > 100) {
      jQuery('#GotoTop').fadeIn();
    } else {
      jQuery('#GotoTop').fadeOut();
    }
  }
});

function responsiveMenu() {
  if (jQuery(window).width() < 992) {
    jQuery('.Site-navigation').insertAfter('.nav-toggle');
    jQuery('.sub-nav__dropdown').css('display', 'none');
  } else {
    jQuery('.Site-navigation').appendTo('.menu_wrapper');
  }

  if (jQuery(window).width() < 992) {
    $(
      '.header_style_1 #shopify-section-TT-mega_menu,.header_style_2 #shopify-section-TT-mega_menu',
    ).appendTo('.ttresponsive_menu');
    $('.header_style_3 #shopify-section-TT-mega_menu').prependTo(
      '.header_3 .menu-bar .header-bottom',
    );
    $('#accessibleNav').appendTo('#tt-megamenu .tt_menus_ul');
    $('.header_1 .header-right').insertAfter('.header-left');
    $('.header_3 .header-right').insertAfter(
      '.header_3 .header-main .header-middle',
    );
    $(
      '.header_style_1 .tt-nav-right-div,.header_style_3 .tt-nav-right-div',
    ).insertAfter('.tt-mega_menu .tt_menus_ul');
    $('.header_2 .header_currency').insertAfter(
      '.header_2 .tt-mega_menu .tt_menus_ul',
    );
    $('.header_2 .header_language').insertAfter(
      '.header_2 .tt-mega_menu .header_currency',
    );
    $('.header_2 .header-middle').insertAfter(
      '.header_2 .main-header .header-right',
    );
    $('.header_2 .menu-bar').insertBefore(
      '.header_2 .main-header .header-left',
    );
    $('.header_3 .header-main .cms-contactus').insertAfter(
      '.header_3 .header-bottom #shopify-section-TT-mega_menu #tt-megamenu .tt-mega_menu .tt_menus_ul',
    );
    $('.header_2 .full-header .cms-contactus').insertAfter(
      '.header_2 .full-header #shopify-section-TT-mega_menu #tt-megamenu .tt-mega_menu .tt_menus_ul',
    );
  } else {
    $(
      '.template-index.header_style_2 #shopify-section-TT-mega_menu',
    ).insertBefore('.header_style_2 .main-content .tt-homeslider');
    $(
      '.header_style_2:not(.template-index) #shopify-section-TT-mega_menu',
    ).insertBefore('.header_style_2 .header-left');
    $('.header_style_1 #shopify-section-TT-mega_menu').insertBefore('.topmenu');
    $('#tt-megamenu .tt_menus_ul #accessibleNav').appendTo('.topmenu');
    $(
      '.header_style_1 .tt-nav-right-div,.header_style_3 .tt-nav-right-div',
    ).insertAfter('.header-top-left');
    $('.header_style_2 .header_currency').appendTo('#top .header-right');
    $('.header_style_2 .header_language').insertAfter('.header_currency');
    $('.header_2 .header-middle').insertAfter(
      '.header_2 .main-header .header-left',
    );
    $('.header_2 .menu-bar').insertAfter(
      '.header_2 .main-header .header-contact-cms',
    );
    $('.header_style_3 #shopify-section-TT-mega_menu').prependTo(
      '.header_3 .menu-bar .header-bottom',
    );
    $('#tt-megamenu .tt_menus_ul .header-right-cms').insertBefore(
      '.full-header .header-middle',
    );
    $('.header_style_1 #accessibleNav').appendTo(
      '.header_style_1 .menu-bar .topmenu .top',
    );
    $('.header_1 .header-right').insertAfter(
      '.header_1 .header-main .header-middle',
    );
    $('.header_3 .header-right').insertAfter(
      '.header_3 .header-main .header-middle',
    );
    $('.header_3 .cms-contactus').appendTo('.header_3 .header-bottom');
  }

  // This menu is rendered after the header, so keep it hidden until it has
  // been moved into its final desktop/mobile container to prevent a reload flash.
  $('[data-header-menu-pending]').removeAttr('style data-header-menu-pending');
}
jQuery(document).ready(function () {
  responsiveMenu();
  refreshHeaderMenuLayout();

  jQuery('.header_style_2  #shopify-section-TT-mega_menu').css(
    'display',
    'block',
  );
  jQuery('.header_1 .header-right').css('display', 'block');
  jQuery('.header_2 .full-header .topmenu').css('display', 'inline-block');
  jQuery('.product-write-review').on('click', function (e) {
    e.preventDefault();
    $("a[href='#tab-2']").trigger('click');
    jQuery('html, body').animate(
      {
        scrollTop: jQuery('.product_tab_wrapper').offset().top - 150,
      },
      1000,
    );
  });
});
jQuery(document).load(function () {});
jQuery(window).resize(function () {
  responsiveMenu();
  refreshHeaderMenuLayout();
  var w_width = $(window).width();
  $('.slider-content-main-wrap').css('width', w_width);
});
jQuery(document).on('shopify:section:load shopify:section:select', function () {
  responsiveMenu();
  refreshHeaderMenuLayout();
});

function footerToggle() {
  if (jQuery(window).width() < 992) {
    if ($('.left-sidebar-menu').length > 0) {
      jQuery('.left-sidebar-menu').appendTo('.ttresponsive_menu');
      if (!jQuery('body').hasClass('header_style_3')) {
        jQuery('.header-right').appendTo('.ttresponsive_menu');
      }
      jQuery('.ttresponsive_menu h4.widget-title').unbind('click');
      jQuery('.ttresponsive_menu  h4.widget-title').on('click', function () {
        jQuery(this)
          .parent()
          .toggleClass('active')
          .children(':nth-child(2)')
          .slideToggle('fast');
      });
    } else {
      jQuery('nav#menu .nav-menu-wrapper').appendTo('.ttresponsive_menu');
      jQuery('.nav-menu-wrapper h4.widget-title').unbind('click');
      jQuery('.nav-menu-wrapper h4.widget-title').on('click', function () {
        jQuery(this)
          .parent()
          .toggleClass('active')
          .children(':nth-child(2)')
          .slideToggle('fast');
      });
    }

    jQuery('.left_sidebar #column-left').insertAfter('#content');
    if (jQuery('.site-footer').hasClass('fixed_footer')) {
      jQuery('.page-wrapper').css('margin-bottom', '0px');
    }
    jQuery(
      '.no_sidebar .left-sidebar.sidebar,.left_sidebar .left-sidebar.sidebar',
    ).insertAfter('.collection_wrapper, .content-wrapper');
    jQuery('.sidebar .sidebar-block').insertAfter('.filter-wrapper');
    jQuery('.sidebar#column-left .collection_sidebar').insertAfter(
      '.filter-wrapper',
    );
    jQuery('.site-footer .widget h5').addClass('toggle');
    jQuery('.site-footer .widget')
      .children(':nth-child(2)')
      .css('display', 'none');
    jQuery('.site-footer .widget.active')
      .children(':nth-child(2)')
      .css('display', 'block');
    jQuery('.site-footer .widget h5.toggle').unbind('click');
    jQuery('.site-footer .widget h5.toggle').on('click', function () {
      jQuery(this)
        .parent()
        .toggleClass('active')
        .children(':nth-child(2)')
        .slideToggle('fast');
    });
    jQuery(
      '#column-left.sidebar .widget > h4,#column-right.sidebar .widget > h4,.right-sidebar.sidebar .widget > h4,.left-sidebar.sidebar .widget > h4,.blog-section .sidebar .widget > h4',
    ).addClass('toggle');
    jQuery(
      '#column-left.sidebar .widget ,#column-right.sidebar .widget,.right-sidebar.sidebar .widget,.left-sidebar.sidebar .widget,.blog-section .sidebar .widget',
    )
      .children(':nth-child(2)')
      .css('display', 'none');
    jQuery(
      '#column-left.sidebar .widget.active,#column-right.sidebar .widget.active,.right-sidebar.sidebar .widget.active,.left-sidebar.sidebar .widget.active,.blog-section .sidebar .widget.active',
    )
      .children(':nth-child(2)')
      .css('display', 'block');
    jQuery(
      '#column-left.sidebar .widget > h4.toggle,#column-right.sidebar .widget > h4.toggle,.right-sidebar.sidebar .widget > h4.toggle,.left-sidebar.sidebar .widget > h4.toggle,.blog-section .sidebar .widget > h4.toggle',
    ).unbind('click');
    jQuery(
      '#column-left.sidebar .widget > h4.toggle,#column-right.sidebar .widget > h4.toggle,.right-sidebar.sidebar .widget > h4.toggle,.left-sidebar.sidebar .widget > h4.toggle,.blog-section .sidebar .widget > h4.toggle',
    ).on('click', function () {
      jQuery(this)
        .parent()
        .toggleClass('active')
        .children(':nth-child(2)')
        .slideToggle('fast');
    });
    jQuery(
      '.left-sidebar .sidebar-block .widget > h4,.right-sidebar .sidebar-block .widget > h4,.collection_right .sidebar-block .widget > h4,.collection_left .sidebar-block .widget > h4,.filter-toggle-wrap .sidebar-block .widget > h4,.content-right .sidebar-block .widget > h4',
    ).addClass('toggle');
    jQuery(
      '.left-sidebar .sidebar-block .widget,.right-sidebar .sidebar-block .widget,.collection_right .sidebar-block .widget,.collection_left .sidebar-block .widget,.filter-toggle-wrap .sidebar-block .widget,.content-right .sidebar-block .widget ',
    )
      .children(':nth-child(2)')
      .css('display', 'none');
    jQuery(
      '.left-sidebar .sidebar-block .widget.active,.right-sidebar .sidebar-block .widget.active,.collection_right .sidebar-block .widget.active,.collection_left .sidebar-block .widget.active,.filter-toggle-wrap .sidebar-block .widget.active,.content-right .sidebar-block .widget.active',
    )
      .children(':nth-child(2)')
      .css('display', 'block');
    jQuery(
      '.left-sidebar .sidebar-block .widget > h4.toggle,.right-sidebar .sidebar-block .widget > h4.toggle,.collection_right .sidebar-block .widget > h4.toggle,.collection_left .sidebar-block .widget > h4.toggle,.filter-toggle-wrap .sidebar-block .widget > h4.toggle,.content-right .sidebar-block .widget > h4.toggle',
    ).unbind('click');
    jQuery(
      '.left-sidebar .sidebar-block .widget > h4.toggle,.right-sidebar .sidebar-block .widget > h4.toggle,.collection_right .sidebar-block .widget > h4.toggle,.collection_left .sidebar-block .widget > h4.toggle,.filter-toggle-wrap .sidebar-block .widget > h4.toggle,.content-right .sidebar-block .widget > h4.toggle',
    ).on('click', function () {
      jQuery(this)
        .parent()
        .toggleClass('active')
        .children(':nth-child(2)')
        .slideToggle('fast');
    });
  } else {
    if ($('.left-sidebar-menu').length > 0) {
      jQuery('#accessibleNav').appendTo('.nav-menu-wrapper .navbar-collapse');
    } else {
      jQuery('.ttresponsive_menu .nav-menu-wrapper').appendTo('nav#menu');
    }
    jQuery('.left-sidebar-menu').appendTo('#shopify-section-left-col-menu');
    jQuery('.left_sidebar #column-left').insertBefore('#content');
    jQuery('.sidebar .sidebar-block').insertAfter(
      '#shopify-section-left-col-menu',
    );
    jQuery('.collection_sidebar').prependTo('.left_column-wrap');
    jQuery('.section-header .sidebar-block').prependTo('.collection_sidebar');
    if (jQuery('.site-footer').hasClass('fixed_footer')) {
      var footer_h = jQuery('.site-footer.fixed_footer').height();
      jQuery('.page-wrapper').css('margin-bottom', footer_h + 'px');
    }
    jQuery(
      '.no_sidebar .left-sidebar.sidebar,.left_sidebar .left-sidebar.sidebar',
    ).insertBefore('.collection_wrapper, .content-wrapper');
    jQuery(
      '.left_sidebar .sidebar .widget > h4,.right_sidebar .sidebar .widget > h4,.no_sidebar .left-sidebar.sidebar .widget > h4,.no_sidebar .right-sidebar.sidebar .widget > h4,.no_sidebar .sidebar-block .widget > h4,.left_sidebar .sidebar-block .widget > h4',
    ).unbind('click');
    jQuery(
      '.left_sidebar .sidebar .widget > h4,.right_sidebar .sidebar .widget > h4,.no_sidebar .left-sidebar.sidebar .widget > h4,.no_sidebar .right-sidebar.sidebar .widget > h4,.no_sidebar .sidebar-block .widget > h4,.left_sidebar .sidebar-block .widget > h4',
    ).removeClass('toggle');
    jQuery(
      '.left_sidebar .sidebar .widget,.right_sidebar .sidebar .widget,.no_sidebar .left-sidebar.sidebar .widget,.no_sidebar .right-sidebar.sidebar .widget,.no_sidebar .sidebar-block .widget,.left_sidebar .sidebar-block .widget',
    )
      .children(':nth-child(2)')
      .css('display', 'block');
    jQuery('.site-footer .widget h5').unbind('click');
    jQuery('.site-footer .widget h5').removeClass('toggle');
    jQuery('.site-footer .widget')
      .children(':nth-child(2)')
      .css('display', 'block');
  }
}
jQuery(document).ready(function () {
  footerToggle();
  sidebarsticky();
});
jQuery(window).load(function () {
  var h = $('.design_4 .product-wrapper-owlslider').height();
  $('.design_4 .product-information-inner.tt-scroll').css(
    'min-height',
    h + 'px',
  );
});
jQuery(window).resize(function () {
  footerToggle();
  var h = $('.design_4 .product-wrapper-owlslider').height();
  $('.design_4 .product-information-inner.tt-scroll').css(
    'min-height',
    h + 'px',
  );
});

function productcartsticky() {
  if (jQuery(window).width() > 1199) {
    if (jQuery(this).scrollTop() > 550) {
      jQuery('.add-to-cart-sticky').addClass('fixed');
    } else {
      jQuery('.add-to-cart-sticky').removeClass('fixed');
    }
  } else {
    jQuery('.add-to-cart-sticky').removeClass('fixed');
  }
}

$(document).ready(function () {
  productcartsticky();
});
jQuery(window).resize(function () {
  productcartsticky();
});
jQuery(window).scroll(function () {
  productcartsticky();
});

function splitStr(string, seperator) {
  return string.split(seperator);
}

function countDownIni(countdown) {
  $(countdown).each(function () {
    var countdown = $(this);
    var promoperiod;
    if (countdown.attr('data-promoperiod')) {
      promoperiod =
        new Date().getTime() + parseInt(countdown.attr('data-promoperiod'), 10);
    } else if (countdown.attr('data-countdown')) {
      promoperiod = countdown.attr('data-countdown');
    }
    if (Date.parse(promoperiod) - Date.parse(new Date()) > 0) {
      $(this).addClass('countdown-block');
      countdown.countdown(promoperiod, function (event) {
        // countdown.html(event.strftime('%-w weeks %-d days %Hh %Mm %Ss'));
        countdown.html(
          event.strftime(
            '<span><span class="left-txt">LEFT</span><span>%D</span><span class="time-txt">days</span></span>' +
              '<span><span>%H</span><span class="time-txt">hours</span></span>' +
              '<span><span>%M</span><span class="time-txt">min</span></span>' +
              '<span><span class="second">%S</span><span class="time-txt">sec</span></span>',
          ),
        );
      });
    }
  });
}

function hb_animated_contents() {
  $('.hb-animate-element:in-viewport').each(function (i) {
    var $this = $(this);
    if (!$this.hasClass('hb-in-viewport')) {
      setTimeout(function () {
        $this.addClass('hb-in-viewport');
      }, 180 * i);
    }
  });
}

$(window).scroll(function () {
  hb_animated_contents();
});
$(window).load(function () {
  hb_animated_contents();
});

function sidebarsticky() {
  if ($(document).width() >= 992 && $(document).width() <= 1199) {
    jQuery(
      '.left_sidebar #left-column,#column-left,.right_sidebar #right-column,#column-right,.no_sidebar .left-sidebar.sidebar,.no_sidebar .right-sidebar.sidebar',
    ).theiaStickySidebar({
      additionalMarginBottom: 30,
      additionalMarginTop: 30,
    });
  } else if ($(document).width() >= 1200) {
    jQuery(
      '.left_sidebar #left-column,#column-left,.right_sidebar #right-column,#column-right,.no_sidebar .left-sidebar.sidebar,.no_sidebar .right-sidebar.sidebar',
    ).theiaStickySidebar({
      additionalMarginBottom: 30,
      additionalMarginTop: 130,
    });
  }
}
jQuery(window).resize(function () {
  sidebarsticky();
});
/* responsive accordian menu*/
$(function () {
  var Accordion = function (el, multiple) {
    this.el = el || {};
    this.multiple = multiple || false;

    // Variables privadas
    var links = this.el.find('.mobile-nav__sublist-trigger');
    // Evento
    links.on('click', { el: this.el, multiple: this.multiple }, this.dropdown);
  };

  Accordion.prototype.dropdown = function (e) {
    var $el = e.data.el;
    (($this = $(this)), ($next = $this.next()));

    $next.slideToggle();
    $this.parent().toggleClass('open');

    if (!e.data.multiple) {
      $el
        .find('.tt_sub_menu_wrap')
        .not($next)
        .slideUp()
        .parent()
        .removeClass('open');
    }
  };

  var accordion = new Accordion($('.tt_menus_ul'), false);
});
$(function () {
  var Accordions = function (el, multiple) {
    this.el = el || {};
    this.multiple = multiple || false;

    // Variables privadas
    var link = this.el.find('.toggle');
    // Evento
    link.on('click', { el: this.el, multiple: this.multiple }, this.dropdown);
  };

  Accordions.prototype.dropdown = function (e) {
    var $el = e.data.el;
    (($this = $(this)), ($next = $this.next()));

    $next.slideToggle();
    $this.parent().toggleClass('active');

    if (!e.data.multiple) {
      $el
        .find('.inline-list')
        .not($next)
        .slideUp()
        .parent()
        .removeClass('active');
    }
  };

  var accordions = new Accordions($('.footer-column'), false);
});
